import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from "@mui/material/IconButton";
import { type ReactElement } from 'react';
import { useAlert } from '../alert/AlertProvider';
import { useLocalizedStrings } from '../../../localization/LocalizedStringsProvider';
import Tooltip from '@mui/material/Tooltip';

export interface DataGridDeleteButtonProps {
    id: string;
    warningMessage?: string;
    getWarningMessage?: (id: string) => string;
    onClick: (id: string) => void;
    "aria-label"?: string,
    hidden?: boolean
}

const DataGridDeleteButton = ({ id, warningMessage, getWarningMessage, onClick, hidden, ...rest }: DataGridDeleteButtonProps): ReactElement => {
    const alert = useAlert();
    const strings = useLocalizedStrings();

    const handleDelete = async (id: string) => {
        const agree = await alert({
            title: strings.confirmDeleteTitle,
            message: warningMessage || getWarningMessage?.(id) || strings.confirmDeleteMessage,
            destructive: true,
            agreeButtonTitle: strings.delete,
            closeButtonTitle: strings.cancel,
        });

        if (agree) {
            onClick(id);
        }
    };

    if (hidden) {
        return (<></>);
    }
    else {
        return (
            <Tooltip title={strings.delete}>
                <IconButton {...rest} onClick={() => handleDelete(id.toString())}>
                    <DeleteIcon color="error" />
                </IconButton>
            </Tooltip>
        );
    }
}

export default DataGridDeleteButton;
